module.exports = __webpack_public_path__ + "img/bloomberg.114889a6.png";